import { Box } from '@mui/material';
import { CorrectionModal } from './CorrectionModal';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface AddCorrectionProps {
  refetchCorections: () => void;
}

export const AddCorrection = ({ refetchCorections }: AddCorrectionProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/corrections');
  };

  const handleSave = () => {
    navigate('/corrections');
    refetchCorections();
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-correction">
      <CorrectionModal
        open={open}
        handleClose={handleClose}
        handleSave={handleSave}
        correction={{}}
      />
    </Box>
  );
};
